import { h } from 'preact'
import TopicLabel from '../topic-list-view/TopicLabel'
import ClampLines from 'react-clamp-lines'
import ProductUpdateDateFormatter from './ProductUpdateDateFormatter'
// import TopicListLikeButton from '../topic-list-view/TopicListLikeButton'
// import TopicComments from '../topic-list-view/TopicComments'
// import TopicLastPost from '../topic-list-view/TopicLastPost'
import { ProductUpdateType } from './Types'
import htmlParser from '../utils/htmlParser'
import Phrase from '../../libs/translationsUtils/phrase'

interface Props extends ProductUpdateType {
  isGuest: boolean,
  key: string,
  productAreasMapping: {
    [key:string]: string
  }
}

const ProductUpdateView = ({ isGuest, id, title, content, publicLabel, replyCount, createdAt, contentType, likes, featuredImage, productAreas, productAreasMapping }: Props) => {
  const strippedContent = htmlParser.stripHtml(content)

  return (
    <article className='product-update-view card-widget-wrapper'>
      <a href={`/product-updates/${id}`} className='product-update-url' aria-label={title}>
        {
          featuredImage ? <img className='product-update-view_feature-image' src={featuredImage} /> : null
        }
        <div className='product-update-view_info'>
          <div className='product-update-view_info--metadata'>
            <TopicLabel topic={{ contentType: contentType, publicLabel: publicLabel }} />
            <span className='text--meta'> { ProductUpdateDateFormatter(createdAt) } </span>
          </div>
          <h4 className='card-widget-title product-update-view_info-title h3'>
            { title }
          </h4>
          <ClampLines
            id='product-update-view'
            className='card-widget-text product-update-view_info-content'
            innerElement='p'
            lines={4}
            text={strippedContent || ''}
            buttons={false}
          />
          {
            productAreas.length ? (
              <div className='product-update-view_product-areas'>
                <span className='text--meta'>
                  <Phrase p='product.areas.related.products' />:
                </span>
                {
                  productAreas.map(productAreaId => <span className='text--dot-underline product-area-item'>
                    { productAreasMapping[productAreaId] }
                  </span>)
                }
              </div>
            ) : null
          }
        </div>
      </a>
    </article>
  )
}
export default ProductUpdateView
